export default __webpack_public_path__ + "static/media/conteudo04.3e1338e4.png";